import { requests } from './requests';

export const requestCreators = {
  [requests.checkLogin]: (email) => {
    const formData = new FormData();
    formData.append('LOGIN', email);

    return {
      method: 'POST',
      data: formData,
    };
  },
};
